import type { AisArticle } from "@expert/types";

export const validatePPMHit = (hit: AisArticle) => {
    return hasStoreData(hit)
        && hasContextSensitiveData(hit);
}

const hasStoreData = (hit: AisArticle, storeId?: string) => {
    const storeDataExists = hit?.storeData && Object.keys(hit?.storeData).length > 0;

    if (storeId) {
        return storeDataExists && hit?.storeData[storeId] && Object.keys(hit?.storeData[storeId]).length > 0;
    } else {
        return storeDataExists;
    }
}

const hasContextSensitiveData = (hit: AisArticle) => {
    return hit?.articleView?.contextSensitiveData && Object.keys(hit?.articleView?.contextSensitiveData).length > 0;
}